// extracted by mini-css-extract-plugin
export default {"root":"ChooseModelAndVersion_root__Srv0a","addInfoManually":"ChooseModelAndVersion_addInfoManually__TkEyQ"};